<template>
  <div class="case">
    <!--    <div class="center" style="font-size: 2em;">-->
    <!--      <h2 style="margin-top: 80px">ZHL压缩技术行业应用</h2>-->
    <!--    </div>-->
    <div class="center">
    <div  v-loading="true" style="height: 30em; width:30em;">


    </div>
    </div>




    <div style="margin-top: 200px">
      <Footer/>
    </div>

  </div>
</template>
<script>
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Banner,
    Footer
  },
  data() {
    return {
      b:0,
      c:0,
      storedValue:0,
      id:0,
      a:"",
      data:[],
      title:"",
      description:"",
      title2:"",
      description2:"",
      title3:"",
      description3:"",
      loading: true,
      caseList: []
    };
  },

  beforeDestroy() {
    // this.$router.push({name:"case"})
  },


  mounted() {



this.a=sessionStorage.getItem('z');


    console.log(this.a)




  },
  created() {

    // 1秒后执行compare函数
    setTimeout(() => {
      this.compare();
    }, 500);

  },
  methods:{


compare(){

  console.log(this.a)


  // sessionStorage存a
  sessionStorage.setItem('x', this.a);


    setTimeout(   this.$router.push({
      name: 'text1', // 使用路由的 name 属性
      params: { a: this.a }
    })  ,1000)






},


    getData() {




    }


  }
};
</script>

<style lang="scss" scoped>


.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  background-color: pink;
}
.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}



.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>